<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div :class="isGenerating">
          <p
            class="mt-0 mb-3 text-md white bold"
          >Só um momento, gerando seu plano de nutrição da semana</p>
          <p class="mt-0 mb-0 text-sm white">
            <ion-icon mode="ios" name="flower" size="large" class="loading-icon"></ion-icon>
          </p>
        </div>
        <ion-row>
          <ion-col size="12">
            <p class="top-title mt-0 mb-0 green text-xxl ion-text-uppercase">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/new-assets%2Fbrand%2FUpdiet_NewIcon.png?alt=media&token=834dbefe-8bfd-4cc4-b8fa-ef6b035414f5"
              />
              Menu da semana
            </p>
            <p class="mt-1 mb-0 dark text-sm">Um novo menu é gerado todo domingo</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="calendar-block mt-4">
              <div class="calendar-header bg-dark">
                <p class="mt-0 mb-0 text-sm white">{{ currentMonth }}</p>
              </div>
              <div class="calendar-body">
                <div class="calendar-weekdays">
                  <div class="arrow-back cursor-pointer" @click="minusWeek">
                    <ion-icon mode="ios" name="arrow-back"></ion-icon>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">D</p>
                    <p :class="day1.class" @click="selectDate('day1')">{{ day1.day }}</p>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">S</p>
                    <p :class="day2.class" @click="selectDate('day2')">{{ day2.day }}</p>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">T</p>
                    <p :class="day3.class" @click="selectDate('day3')">{{ day3.day }}</p>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">Q</p>
                    <p :class="day4.class" @click="selectDate('day4')">{{ day4.day }}</p>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">Q</p>
                    <p :class="day5.class" @click="selectDate('day5')">{{ day5.day }}</p>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">S</p>
                    <p
                      :class="day6.class"
                      value="16/11/2019"
                      @click="selectDate('day6')"
                    >{{ day6.day }}</p>
                  </div>
                  <div class="weekday">
                    <p class="mt-0 mb-1 text-sm darkgrey">S</p>
                    <p
                      :class="day7.class"
                      value="17/11/2019"
                      @click="selectDate('day7')"
                    >{{ day7.day }}</p>
                  </div>
                  <div
                    v-if="plusWeekAllowed"
                    class="arrow-forward cursor-pointer"
                    @click="plusWeek"
                  >
                    <ion-icon mode="ios" name="arrow-forward"></ion-icon>
                  </div>
                  <div v-else class="arrow-forward white">
                    <ion-icon mode="ios" name="arrow-forward"></ion-icon>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="pt-3">
          <ion-col size="12">
            <div v-if="meals.length > 0">
              <div class="daily-target mb-3 pl-3 pr-3">
                <div class="ion-text-center">
                  <p class="mt-0 mb-0 dark text-sm">kcal</p>
                  <p class="mt-0 mb-0 white text-sm bold ion-text-wrap">{{ dailyValue.calories }}</p>
                </div>
                <div class="ion-text-center">
                  <p class="mt-0 mb-0 dark text-sm">proteína</p>
                  <p class="mt-0 mb-0 white text-sm bold ion-text-wrap">{{ dailyValue.protein }}g</p>
                </div>
                <div class="ion-text-center">
                  <p class="mt-0 mb-0 dark text-sm">carbs</p>
                  <p class="mt-0 mb-0 white text-sm bold ion-text-wrap">{{ dailyValue.carbs }}g</p>
                </div>
                <div class="ion-text-center">
                  <p class="mt-0 mb-0 dark text-sm">lipídeos</p>
                  <p class="mt-0 mb-0 white text-sm bold ion-text-wrap">{{ dailyValue.fat }}g</p>
                </div>
              </div>
              <div class="meals mt-2" v-for="meal in meals" :key="meal.index">
                <div class="meal pt-0 pb-0 mb-2 cursor-pointer" @click="gotoMeal(meal)">
                  <ion-item lines="none" no-padding>
                    <ion-avatar slot="start" class="meal-avatar">
                      <ion-img v-if="meal.data.picture" :src="meal.data.picture"></ion-img>
                      <ion-img
                        v-else
                        src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
                      ></ion-img>
                    </ion-avatar>
                    <ion-label>
                      <p class="mt-0 mb-0 ion-text-uppercase grey text-xs">{{ meal.data.mealName }}</p>
                      <p class="mt-0 mb-0 dark text-sm bold ion-text-wrap">{{ meal.data.namePT }}</p>
                    </ion-label>
                  </ion-item>
                  <div class="meal-icon">
                    <ion-icon mode="ios" name="arrow-dropright-circle" color="primary"></ion-icon>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p
                class="mt-5 mb-5 grey text-sm ion-text-center"
              >Nenhuma refeição encontrada para esse dia</p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <TabBar
      mealsClass="white tab-green"
      shoppingClass="tab-grey"
      profileClass="tab-grey"
      recipesClass="tab-grey"
    />
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";
// moment
import moment from "moment";
moment.locale("pt-br");
// tab bar
import TabBar from "../../partials/structural/TabBar.vue";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// utils
import generateWeeklyMealplan from "../../utils/mealplan.js";
import getMeals from "../../utils/get-meals.js";
function translateMonth(month) {
  let translatedMonth = month;
  if (month === "January") {
    translatedMonth = "Janeiro";
  } else if (month === "February") {
    translatedMonth = "Fevereiro";
  } else if (month === "March") {
    translatedMonth = "Março";
  } else if (month === "April") {
    translatedMonth = "Abril";
  } else if (month === "May") {
    translatedMonth = "Maio";
  } else if (month === "June") {
    translatedMonth = "Junho";
  } else if (month === "July") {
    translatedMonth = "Julho";
  } else if (month === "August") {
    translatedMonth = "Agosto";
  } else if (month === "September") {
    translatedMonth = "Setembro";
  } else if (month === "October") {
    translatedMonth = "Outubro";
  } else if (month === "November") {
    translatedMonth = "Novembro";
  } else if (month === "December") {
    translatedMonth = "Dezembro";
  } else {
    //
  }
  return translatedMonth;
}
// component
export default {
  name: "MealPlan",
  components: {
    TabBar,
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      isGenerating: "d-none",
      user: store.state.user,
      profile: store.state.profile,
      dailyValue: {
        calories: 0,
        protein: 0,
        carbs: 0,
        fat: 0
      },
      currentMonth: null,
      daySelected: null,
      day1: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      day2: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      day3: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      day4: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      day5: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      day6: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      day7: {
        day: null,
        date: null,
        class: "mt-0 mb-0 text-sm bold date-regular"
      },
      lastDay: null,
      plusWeekAllowed: false,
      meals: []
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoMeal(meal) {
      this.$router.push({
        name: "Meal",
        params: {
          mealplanId: meal.data.mealplanId,
          meal: meal.data.meal,
          dishId: meal.id,
          proportion: meal.data.proportion
        }
      });
    },
    clearDates() {
      this.day1.class = "mt-0 mb-0 text-sm bold date-regular";
      this.day2.class = "mt-0 mb-0 text-sm bold date-regular";
      this.day3.class = "mt-0 mb-0 text-sm bold date-regular";
      this.day4.class = "mt-0 mb-0 text-sm bold date-regular";
      this.day5.class = "mt-0 mb-0 text-sm bold date-regular";
      this.day6.class = "mt-0 mb-0 text-sm bold date-regular";
      this.day7.class = "mt-0 mb-0 text-sm bold date-regular";
    },
    async selectDate(date) {
      const instance = this;
      instance.startLoading();
      if (date === "day1") {
        instance.clearDates();
        instance.day1.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day1.date;
      } else if (date === "day2") {
        instance.clearDates();
        instance.day2.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day2.date;
      } else if (date === "day3") {
        instance.clearDates();
        instance.day3.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day3.date;
      } else if (date === "day4") {
        instance.clearDates();
        instance.day4.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day4.date;
      } else if (date === "day5") {
        instance.clearDates();
        instance.day5.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day5.date;
      } else if (date === "day6") {
        instance.clearDates();
        instance.day6.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day6.date;
      } else {
        instance.clearDates();
        instance.day7.class = "mt-0 mb-0 text-sm bold date-selected";
        instance.daySelected = instance.day7.date;
      }
      let meals = [];
      const today = moment(instance.daySelected).format("DD/MM/YYYY");
      const todayRaw = moment(instance.daySelected);
      const now = moment();
      const mealplansInStore = store.state.mealplans;
      let flag;
      for (let i = 0; i < mealplansInStore.length; i++) {
        if (mealplansInStore[i].day === today) {
          flag = true;
          meals = mealplansInStore[i].meals;
        }
      }
      if (!flag) {
        let mpRef = db
          .collection("mealplans")
          .where("userId", "==", instance.user.uid)
          .where("day", "==", today);
        let snapshot = await mpRef.get();
        if (snapshot.empty && moment(now).isBefore(todayRaw)) {
          instance.isLoading = false;
          instance.isGenerating = "generating-banner";
          /*
          const generateWeeklyMealplan = firebase
            .functions()
            .httpsCallable("generateWeeklyMealplan");
          await generateWeeklyMealplan({ userId: instance.user.uid });
          */
          await generateWeeklyMealplan(instance.user.uid);
          snapshot = await mpRef.get();
        }
        meals = await getMeals(snapshot);
        const mealsObj = {
          day: today,
          meals: meals
        };
        if (mealsObj.meals.length > 0) {
          store.addMealplan(mealsObj);
        }
      }
      let dailyValue = {
        calories: 0,
        protein: 0,
        carbs: 0,
        fat: 0
      };
      for (let i in meals) {
        dailyValue.calories +=
          (meals[i].data.nutritionalInfo.calories * meals[i].data.proportion) /
          100;
        dailyValue.protein +=
          (meals[i].data.nutritionalInfo.protein * meals[i].data.proportion) /
          100 /
          1000;
        dailyValue.carbs +=
          (meals[i].data.nutritionalInfo.carbs * meals[i].data.proportion) /
          100 /
          1000;
        dailyValue.fat +=
          (meals[i].data.nutritionalInfo.fat * meals[i].data.proportion) /
          100 /
          1000;
      }
      dailyValue.calories = Math.floor(dailyValue.calories);
      dailyValue.protein = Math.floor(dailyValue.protein);
      dailyValue.carbs = Math.floor(dailyValue.carbs);
      dailyValue.fat = Math.floor(dailyValue.fat);
      instance.dailyValue = dailyValue;
      instance.meals = meals;
      instance.isGenerating = "d-none";
      instance.isLoading = false;
    },
    plusWeek() {
      this.clearDates();

      const fromDate = moment(this.day1.date)
        .add(1, "weeks")
        .startOf("week");

      this.day1.date = fromDate;
      this.day1.day = moment(this.day1.date).date();

      this.day2.date = moment(fromDate).add(1, "days");
      this.day2.day = moment(this.day2.date).date();

      this.day3.date = moment(fromDate).add(2, "days");
      this.day3.day = moment(this.day3.date).date();

      this.day4.date = moment(fromDate).add(3, "days");
      this.day4.day = moment(this.day4.date).date();

      this.day5.date = moment(fromDate).add(4, "days");
      this.day5.day = moment(this.day5.date).date();

      this.day6.date = moment(fromDate).add(5, "days");
      this.day6.day = moment(this.day6.date).date();

      this.day7.date = moment(fromDate).add(6, "days");
      this.day7.day = moment(this.day7.date).date();

      if (this.day1.day > this.day7.day) {
        const day1Month = moment(this.day1.date).format("MMMM");
        const day7Month = moment(this.day7.date).format("MMMM");
        const day1MonthTranslated = translateMonth(day1Month);
        const day7MonthTranslated = translateMonth(day7Month);
        this.currentMonth = `${day1MonthTranslated} - ${day7MonthTranslated}`;
      } else {
        const day1Month = moment(this.day1.date).format("MMMM");
        const day1MonthTranslated = translateMonth(day1Month);
        this.currentMonth = day1MonthTranslated;
      }

      const daySelected = this.daySelected;

      if (moment(daySelected).isSame(this.day1.date, "day")) {
        this.day1.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day2.date, "day")) {
        this.day2.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day3.date, "day")) {
        this.day3.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day4.date, "day")) {
        this.day4.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day5.date, "day")) {
        this.day5.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day6.date, "day")) {
        this.day6.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day7.date, "day")) {
        this.day7.class = "mt-0 mb-0 text-sm bold date-selected";
      } else {
        //
      }

      if (moment(this.day7.date).isBefore(this.lastDay)) {
        this.plusWeekAllowed = true;
      } else {
        this.plusWeekAllowed = false;
      }
    },
    minusWeek() {
      this.clearDates();

      const fromDate = moment(this.day1.date)
        .subtract(1, "weeks")
        .startOf("week");

      this.day1.date = fromDate;
      this.day1.day = moment(this.day1.date).date();

      this.day2.date = moment(fromDate).add(1, "days");
      this.day2.day = moment(this.day2.date).date();

      this.day3.date = moment(fromDate).add(2, "days");
      this.day3.day = moment(this.day3.date).date();

      this.day4.date = moment(fromDate).add(3, "days");
      this.day4.day = moment(this.day4.date).date();

      this.day5.date = moment(fromDate).add(4, "days");
      this.day5.day = moment(this.day5.date).date();

      this.day6.date = moment(fromDate).add(5, "days");
      this.day6.day = moment(this.day6.date).date();

      this.day7.date = moment(fromDate).add(6, "days");
      this.day7.day = moment(this.day7.date).date();

      if (this.day1.day > this.day7.day) {
        const day1Month = moment(this.day1.date).format("MMMM");
        const day7Month = moment(this.day7.date).format("MMMM");
        const day1MonthTranslated = translateMonth(day1Month);
        const day7MonthTranslated = translateMonth(day7Month);
        this.currentMonth = `${day1MonthTranslated} - ${day7MonthTranslated}`;
      } else {
        const day1Month = moment(this.day1.date).format("MMMM");
        const day1MonthTranslated = translateMonth(day1Month);
        this.currentMonth = day1MonthTranslated;
      }

      const daySelected = this.daySelected;

      console.log(daySelected);

      if (moment(daySelected).isSame(this.day1.date, "day")) {
        console.log("day 1");
        this.day1.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day2.date, "day")) {
        console.log("day 2");
        this.day2.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day3.date, "day")) {
        console.log("day 3");
        this.day3.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day4.date, "day")) {
        console.log("day 4");
        this.day4.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day5.date, "day")) {
        console.log("day 5");
        this.day5.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day6.date, "day")) {
        console.log("day 6");
        this.day6.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (moment(daySelected).isSame(this.day7.date, "day")) {
        console.log("day 7");
        this.day7.class = "mt-0 mb-0 text-sm bold date-selected";
      } else {
        console.log("else");
      }

      if (moment(this.day7.date).isBefore(this.lastDay)) {
        this.plusWeekAllowed = true;
      } else {
        this.plusWeekAllowed = false;
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      if (instance.profile) {
        if (
          !instance.profile.data.goal ||
          !instance.profile.data.target.kcal ||
          instance.profile.data.target.kcal < 0
        ) {
          instance.$router.push({
            name: "Onboarding: Goal"
          });
          return;
        }
      }
      // check if subscription is active
      if (!instance.profile.data.subscriptionStatus) {
        const userRef = db.collection("users").doc(instance.profile.id);
        const userDoc = await userRef.get();
        const userData = userDoc.data();
        if (!userData.subscriptionStatus) {
          instance.$router.push({
            name: "Subscribe"
          });
          return;
        }
      }
      // initialize dates
      let dayOfWeek;
      let fromDate;
      if (instance.$route.params.day) {
        const rawDate = instance.$route.params.day;
        const dateParam = moment(rawDate, "DD-MM-YYYY").format();
        instance.daySelected = dateParam;
        dayOfWeek = moment(dateParam).isoWeekday();
        fromDate = moment(dateParam).startOf("week");
      } else {
        const today = moment();
        instance.daySelected = moment(today);
        dayOfWeek = moment(today).isoWeekday();
        fromDate = moment(today).startOf("week");
      }

      instance.day1.date = fromDate;
      instance.day1.day = moment(instance.day1.date).date();

      instance.day2.date = moment(fromDate).add(1, "days");
      instance.day2.day = moment(instance.day2.date).date();

      instance.day3.date = moment(fromDate).add(2, "days");
      instance.day3.day = moment(instance.day3.date).date();

      instance.day4.date = moment(fromDate).add(3, "days");
      instance.day4.day = moment(instance.day4.date).date();

      instance.day5.date = moment(fromDate).add(4, "days");
      instance.day5.day = moment(instance.day5.date).date();

      instance.day6.date = moment(fromDate).add(5, "days");
      instance.day6.day = moment(instance.day6.date).date();

      instance.day7.date = moment(fromDate).add(6, "days");
      instance.day7.day = moment(instance.day7.date).date();

      instance.lastDay = instance.day7.date;

      if (instance.day1.day > instance.day7.day) {
        const day1Month = moment(instance.day1.date).format("MMMM");
        const day7Month = moment(instance.day7.date).format("MMMM");
        const day1MonthTranslated = translateMonth(day1Month);
        const day7MonthTranslated = translateMonth(day7Month);
        instance.currentMonth = `${day1MonthTranslated} - ${day7MonthTranslated}`;
      } else {
        const day1Month = moment(instance.day1.date).format("MMMM");
        const day1MonthTranslated = translateMonth(day1Month);
        instance.currentMonth = day1MonthTranslated;
      }

      if (dayOfWeek === 1) {
        instance.day2.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (dayOfWeek === 2) {
        instance.day3.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (dayOfWeek === 3) {
        instance.day4.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (dayOfWeek === 4) {
        instance.day5.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (dayOfWeek === 5) {
        instance.day6.class = "mt-0 mb-0 text-sm bold date-selected";
      } else if (dayOfWeek === 6) {
        instance.day7.class = "mt-0 mb-0 text-sm bold date-selected";
      } else {
        instance.day1.class = "mt-0 mb-0 text-sm bold date-selected";
      }
      // get mealplans
      let meals = [];
      const today = moment(instance.daySelected).format("DD/MM/YYYY");

      // check if the mealplan for today is in store
      const mealplansInStore = store.state.mealplans;
      let flag;
      for (let i = 0; i < mealplansInStore.length; i++) {
        if (mealplansInStore[i].day === today) {
          flag = true;
          meals = mealplansInStore[i].meals;
        }
      }

      // if it's not, get it from the db
      if (!flag) {
        const mpRef = db
          .collection("mealplans")
          .where("userId", "==", instance.user.uid)
          .where("day", "==", today);
        let snapshot = await mpRef.get();
        let generatedFlag = false;
        if (snapshot.empty) {
          generatedFlag = true;
          instance.isLoading = false;
          instance.isGenerating = "generating-banner";
          /*
          const generateWeeklyMealplan = firebase
            .functions()
            .httpsCallable("generateWeeklyMealplan");
          await generateWeeklyMealplan({ userId: instance.user.uid });
          */
          await generateWeeklyMealplan(instance.user.uid);
        }

        let mealsObj;

        if (!generatedFlag) {
          // process result
          meals = await getMeals(snapshot);
          mealsObj = {
            day: today,
            meals: meals
          };
        } else {
          let counter = 0;
          do {
            counter += 1;
            if (counter > 20) {
              break;
            } else {
              snapshot = await mpRef.get();
            }
          } while (snapshot.size < instance.profile.data.meals.length);
          meals = await getMeals(snapshot);
          mealsObj = {
            day: today,
            meals: meals
          };
        }

        // add the result to the store
        if (mealsObj.meals.length > 0) {
          store.addMealplan(mealsObj);
        }
      }
      let dailyValue = {
        calories: 0,
        protein: 0,
        carbs: 0,
        fat: 0
      };
      for (let i in meals) {
        dailyValue.calories +=
          (meals[i].data.nutritionalInfo.calories * meals[i].data.proportion) /
          100;
        dailyValue.protein +=
          (meals[i].data.nutritionalInfo.protein * meals[i].data.proportion) /
          100 /
          1000;
        dailyValue.carbs +=
          (meals[i].data.nutritionalInfo.carbs * meals[i].data.proportion) /
          100 /
          1000;
        dailyValue.fat +=
          (meals[i].data.nutritionalInfo.fat * meals[i].data.proportion) /
          100 /
          1000;
      }
      dailyValue.calories = Math.floor(dailyValue.calories);
      dailyValue.protein = Math.floor(dailyValue.protein);
      dailyValue.carbs = Math.floor(dailyValue.carbs);
      dailyValue.fat = Math.floor(dailyValue.fat);
      instance.dailyValue = dailyValue;
      // add found meals to the page instance
      instance.meals = meals;
      instance.isGenerating = "d-none";
      instance.isLoading = false;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}

ion-content {
  --padding-bottom: 50px;
  --background: transparent !important;
}

.calendar-block {
  position: relative;
  margin-top: 4vh;
  width: 100%;
  border-radius: 15px;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
}

.calendar-header {
  background: var(--ion-color-dark) !important;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 15px 15px 0 0;
}

.calendar-body {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
}

.calendar-weekdays {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  width: 100%;
}

.date-regular {
  background: white;
  width: 30px;
  height: 30px;
  padding: 7px;
  font-size: 0.7rem !important;
  border-radius: 50%;
  color: #333333;
  cursor: pointer;
}

.date-selected {
  background: rgba(148, 206, 72, 0.2);
  width: 30px;
  height: 30px;
  padding: 7px;
  font-size: 0.7rem !important;
  border-radius: 50%;
  color: var(--ion-color-primary);
  cursor: pointer;
}

ion-item {
  --padding-start: 10px;
}

.meal {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px !important;
  width: 100%;
  border-radius: 15px !important;
  background: white;
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
  padding-right: 10px;
}

.daily-target {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px !important;
  width: 100%;
  border-radius: 15px !important;
  background: var(--ion-color-primary);
  box-shadow: 0 12px 6px -3px rgba(0, 0, 0, 0.15);
  padding-right: 10px;
}

.meal-avatar {
  height: 50px;
  width: 50px;
}

.meal-icon {
  width: 1.75rem !important;
}

.meal-icon ion-icon {
  font-size: 1.75rem !important;
}

.weight-button {
  display: flex;
  flex-direction: column;
  vertical-align: center;
  position: absolute;
  text-align: center;
  top: var(--standard-padding-top);
  right: -5px;
  width: 60px;
  background: var(--bg-color-blue) !important;
  border-radius: 20px 0 0 20px;
  font-size: 1.6rem;
  z-index: 1000;
  box-shadow: 3px 6px 3px -3px rgba(0, 0, 0, 0.15);
}

.weight-div {
  height: 30px !important;
}

.weight-icon {
  font-size: 30px;
  line-height: 30px;
  color: white !important;
}
</style>